import { Injectable } from '@angular/core';
import { SimpleChipExpression } from '@nrwl/query-emitter';
import { ChipConverterProvider } from '@nrwl/at-web-query';
import { cloneDeep, find } from 'lodash';

@Injectable()
export class ChipExpressionEventProvider {
  constructor(private readonly queryTranslator: ChipConverterProvider) {}

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  async buildEvent(searchExpression: SimpleChipExpression[]) {
    if (searchExpression) {
      const clonedCopy = cloneDeep(searchExpression);
      const translatedExpression = await this.queryTranslator.translate(
        cloneDeep(searchExpression)
      );
      return {
        navigate_keyword: this.resolveNavigateKeyword(translatedExpression),
        // expression ready to be passed over to query building templates
        expression: translatedExpression,
        // original expression. may contain keywords, not understood by backend or query building template
        // suggested to use if you want to build human-friendly representation of the expression
        // eg "Location: Stockholm,Sweden" is human readable expression.
        // its counterpart in translated expression would look like this: "sites in (10001, 10004, 10005)"
        human_readable: clonedCopy,
        // assume full update always - and let it be edited before sending out
        update_type: 'full'
      };
    } else {
      return {};
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  resolveNavigateKeyword(expressions: any): string {
    const priorities = ['ip', 'dns', 'user', 'app', 'site'];

    for (let i = 0; i < priorities.length; i++) {
      if (find(expressions, { keyword: priorities[i], operator: '=' })) {
        return priorities[i];
      }
    }

    return '';
  }
}
